// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { getGroupEmp } from '../../../../store/HR/HRSetting/groupEmpSlice';
import { Card, CardBody } from '../../../../components/card/card';
import AddGroupEmployees from './AddGroupEmployees';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import Loader from '../../../../components/Shared/Loader/Loader';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import Loading from '../../../../components/Shared/Loader/Loading';
import EditGroupEmployees from './EditGroupEmployees';
import NtxTable from '../../../../components/DataTable/NtxTable';

const GroupEmployees = () => {
  const { HasPermission } = usePermissions();
  const [id, setId] = useState('');

  const [Show, setShow] = useState(false);
  const { GroupEmps, loading, error } = useSelector(state => state.Groups);
  const dispatch = useDispatch();
  useEffect(() => {
    if (GroupEmps?.length === 0) {
      dispatch(getGroupEmp());
    }
  }, []);

  const { t, i18n } = useTranslation();

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = GroupEmps?.map(item => {
    let rowClass;

    return {
      Name: i18n.language === 'en' ? item.name : item.name2,
      action: (
        <>
          {HasPermission('ViewDetailsHrPerGroups') && (
            <button
              type='button'
              className='btn btn-sm btn-outline-theme'
              data-bs-toggle='modal'
              data-bs-target='#Update'
              onClick={() => setId(item.id)}
            >
              <i className='far fa-lg fa-fw  fa-edit mx-1'></i>
              {t('ViewDetails')}
            </button>
          )}
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: t('Staffgroup'),
      link: null
    }
  ];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('Staffgroup')} />
        {HasPermission('AddHrPerGroups') && (
          <div className='ms-auto'>
            <Link
              to=''
              className='btn me-1 btn-theme'
              data-bs-toggle='modal'
              data-bs-target='#modalAddGroup'
              onClick={() => setShow(true)}
            >
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('AddNewStaffGroup')}
            </Link>
          </div>
        )}
      </div>
      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddStaffGroup')} id='modalAddGroup' size='lg'>
        {Show && <AddGroupEmployees />}
      </ModalComponent>

      <ModalComponent id='Update' title={t('EditStaffGroup')} size='lg'>
        {id && <EditGroupEmployees id={id} />}
      </ModalComponent>
    </>
  );
};

export default GroupEmployees;
